var exports = {
  "N": "xe564cbfb--6c4eb2--element",
};

module.exports = exports;
